module.exports = __webpack_public_path__ + "static/media/fmm_banner.f681323d.svg";